// removed by extract-text-webpack-plugin
module.exports = {"root":"_11kVa","content":"_8XA__","up":"_2Tk9X","footer":"_3RseI"};


//////////////////
// WEBPACK FOOTER
// ./app/layouts/SinglePageLayout/SinglePageLayout.scss
// module id = 1636
// module chunks = 14